var sizeData = [];
const jsonPath = '//www.veimia.com/cdn/shop/t/205/assets/cup-size.json?v=128060984085201157821755504929'
  $.getJSON(jsonPath, function (data) {
    sizeData = data;
  });
  const calculate = (upperBust, underBust) => {
    let result = null;
    const cutValue = upperBust - underBust;
    if (cutValue > 0) {
      $.each(sizeData, (k, size) => {
        const inspectRnderBust = underBust >= size.underBust.min && underBust <= size.underBust.max;
        const inspectCutValue = cutValue >= size.range.min && cutValue < size.range.max;
        if (inspectRnderBust && inspectCutValue) {
          result = size;
        }
      });
    }
    return result;
  };
  const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  };

  const checkInput = (calculateId) => {
    const upperBust = parseFloat(
      $('#' + calculateId)
        .find('.upper-bust')
        .val()
    );
    const underBust = parseFloat(
      $('#' + calculateId)
        .find('.under-bust')
        .val()
    );
    if (!Number.isNaN(upperBust) && !Number.isNaN(underBust)) {
      const size = calculate(upperBust, underBust);
      const cupSize = size ? size.cupSize : 'エラー';
      $('#' + calculateId)
        .find('.calc-results')
        .val(cupSize);
        window.sensors && sensors.track('calculate_size', {
          slot_id: $('#' + calculateId).find('.content_type').val(),
          sub_module: "result",
          section_name:"home calculator",
          extra_data: `${upperBust}+${underBust}=${cupSize}`,
        });
    } else {
      $('#' + calculateId)
        .find('.calc-results')
        .val('');
    }
  };
  const processChange = debounce((calculateId) => checkInput(calculateId));

  $(document).ready(function () {
    $('.calculator-nav').click(function () {
      $('.calculator-wrapper').toggleClass('hide');
    });
  });